export default __webpack_public_path__ + "media/icons/chevron_right-e1b39006.svg";